import { useState } from 'react'
import styles from './ProjectGallery.module.css'

const ProjectGallery = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? Math.max(images.length - 1, 0) : prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))
  }

  return (
    <section className={styles.projectGallery}>
      <div className={styles.container}>
        <div className={styles.textSection}>
          <h2 className={styles.title}>Sneak Peaks to our Site Projects!</h2>
          <p className={styles.subtitle}>Our priority is your satisfaction.</p>
        </div>

        <div className={styles.carouselSection}>
          {images.length > 0 ? (
            <div className={styles.carousel}>
              <img
                src={images[currentIndex]}
                alt={`Project ${currentIndex + 1}`}
                className={styles.image}
              />
              <button
                className={`${styles.navButton} ${styles.prevButton}`}
                onClick={handlePrev}
                aria-label="Previous image"
              >
                ‹
              </button>
              <button
                className={`${styles.navButton} ${styles.nextButton}`}
                onClick={handleNext}
                aria-label="Next image"
              >
                ›
              </button>
            </div>
          ) : (
            <div className={styles.placeholder}>
              <span>Project Images</span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default ProjectGallery
